
import { useRouter } from "next/router";

export default function DropdownFilter({searchKey, options, label, className, searchState, disableFirst, collectionPageChange, collectionSlug }) {
  const router =  useRouter() 
  const handleChange = (event) => {
    if (collectionPageChange) {
    
      if (event.target.value !== '') {
      router.replace(
        {
          pathname: `/lex-cms/collections/${event.target.value}`,
          query: {} 
        },
        undefined,
        {
          shallow: true,
          scroll: false
        }
      )
      }

    }
     else {
      searchState.addValueAtKey(searchKey, event.target.value)
    }

  };
  let selectedValue; 
  if (collectionPageChange) {
    selectedValue =  collectionSlug
  }
  else {
   selectedValue = searchState.search[searchKey] || '';
  }
  

  return (
    <form className={className}>
      <select aria-label={label} name={searchKey} value={selectedValue}  onChange={handleChange}>
        <option value={''} disabled={disableFirst} >
          {label}
        </option>
        {options && options.length > 0 && options.map((d, i) => {
          return (<
            option key={i} value={d?.value || d?.id} >
            {d?.label || d?.name}
          </option>
          )
        })
        }
      </select>
    </form>
  );
}
